import { toCurrency } from 'shared/format-utils'

/**
 * Returns a formatted monetary amount or masked characters.
 * @param amount - Monetary amount.
 * @param isVisible - Define if the amount will be displayed or masked.
 * @returns A string with the formatted or masked amount.
 *
 * @example
 * ```ts
 * maskCurrency(1234, false) // Output: '•••••••'
 * maskCurrency(1234, true) // Output: 'R$ 12,34'
 * ```
 */
export function maskCurrency(amount: number, isVisible: boolean): string {
  return isVisible ? toCurrency(amount) : '••••'
}
